module.exports = __webpack_public_path__ + "img/badge-stat.47d6afca.svg";